import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@adflow/frontend/util-query';
import { GetGoogleAdsAccounts } from '@adflow/shared/data-google-ads';

export const googleAdsAccountKeys = {
	all: ['google-ads', 'account'] as const,
	allList: () => [...googleAdsAccountKeys.all, 'list'] as const,
	// list: (query: ListGoogleAdsAccountsQuery) =>
	// 	[...googleAdsAccountKeys.allList(), query] as const,
};

export function useGoogleAdsAccountsQuery() {
	return useQuery({
		queryKey: googleAdsAccountKeys.allList(),
		queryFn: ({ signal }) => apiRequest(GetGoogleAdsAccounts, {}, { signal }),
		enabled: true,
	});
}
